/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const V1PaymentAassetKind = {
    Ton: 'ton',
    TonStars: 'ton_stars'
} as const
export type V1PaymentAassetKind =
    (typeof V1PaymentAassetKind)[keyof typeof V1PaymentAassetKind]

export function instanceOfV1PaymentAassetKind(value: any): boolean {
    for (const key in V1PaymentAassetKind) {
        if (Object.prototype.hasOwnProperty.call(V1PaymentAassetKind, key)) {
            if (
                V1PaymentAassetKind[key as keyof typeof V1PaymentAassetKind] ===
                value
            ) {
                return true
            }
        }
    }
    return false
}

export function V1PaymentAassetKindFromJSON(json: any): V1PaymentAassetKind {
    return V1PaymentAassetKindFromJSONTyped(json, false)
}

export function V1PaymentAassetKindFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1PaymentAassetKind {
    return json as V1PaymentAassetKind
}

export function V1PaymentAassetKindToJSON(
    value?: V1PaymentAassetKind | null
): any {
    return value as any
}

export function V1PaymentAassetKindToJSONTyped(
    value: any,
    ignoreDiscriminator: boolean
): V1PaymentAassetKind {
    return value as V1PaymentAassetKind
}
